import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "portal-shell" }
const _hoisted_2 = { class: "drawer-brand" }
const _hoisted_3 = { class: "drawer-nav" }
const _hoisted_4 = { class: "nav-caption" }
const _hoisted_5 = {
  class: "nav-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_6 = ["d"]
const _hoisted_7 = ["href", "target", "rel"]
const _hoisted_8 = {
  class: "nav-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_9 = ["d"]
const _hoisted_10 = {
  key: 0,
  class: "nav-external",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_11 = ["d"]
const _hoisted_12 = { class: "drawer-footer" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "org-icon" }
const _hoisted_15 = { class: "org-copy" }
const _hoisted_16 = { class: "org-name" }
const _hoisted_17 = {
  class: "org-switch",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_18 = ["d"]
const _hoisted_19 = {
  key: 1,
  class: "drawer-user"
}
const _hoisted_20 = { class: "user-email" }
const _hoisted_21 = { class: "user-role" }
const _hoisted_22 = { class: "portal-main" }
const _hoisted_23 = { class: "portal-header" }
const _hoisted_24 = { class: "header-title" }
const _hoisted_25 = { class: "crumb-current" }
const _hoisted_26 = { class: "header-actions" }
const _hoisted_27 = ["title", "aria-label"]
const _hoisted_28 = {
  key: 0,
  class: "header-user"
}
const _hoisted_29 = { class: "user-avatar" }
const _hoisted_30 = { class: "portal-scroll" }
const _hoisted_31 = { class: "portal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "scrim" }, {
      default: _withCtx(() => [
        (_ctx.drawer)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "portal-scrim",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawer = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("aside", {
      class: _normalizeClass(["portal-drawer", { open: _ctx.drawer }]),
      "aria-label": "Hoofdmenu"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "brand-link",
          to: "/overview/flow"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "brand-mark" }, [
              _createElementVNode("img", {
                src: "/favicon.ico",
                alt: ""
              })
            ], -1),
            _createElementVNode("span", { class: "brand-wordmark" }, [
              _createElementVNode("span", { class: "brand-name" }, "Simplex"),
              _createElementVNode("span", { class: "brand-product" }, "Flow")
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleNavigation, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav-group", { bottom: group.bottom }]),
            key: group.caption
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(group.caption), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.label
              }, [
                (item.to)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: _normalizeClass(["nav-item", { active: _ctx.isActive(item) }]),
                      to: item.to
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                          _createElementVNode("path", {
                            d: item.icon
                          }, null, 8, _hoisted_6)
                        ])),
                        _createElementVNode("span", null, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "nav-item",
                      href: item.href,
                      target: item.external ? "_blank" : undefined,
                      rel: item.external ? "noopener noreferrer" : undefined
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                        _createElementVNode("path", {
                          d: item.icon
                        }, null, 8, _hoisted_9)
                      ])),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1),
                      (item.external)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                            _createElementVNode("path", { d: _ctx.mdiOpenInNew }, null, 8, _hoisted_11)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_7))
              ], 64))
            }), 128))
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "org-card",
              href: _ctx.organizationsUrl,
              title: "Wissel van organisatie"
            }, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.organizationInitial), 1),
              _createElementVNode("span", _hoisted_15, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "org-label" }, "Organisatie", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.user.organization), 1)
              ]),
              (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                _createElementVNode("path", { d: _ctx.mdiUnfoldMoreHorizontal }, null, 8, _hoisted_18)
              ]))
            ], 8, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.user.token?.email), 1),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.user.hasAdminRights ? 'Admin' : 'Gebruiker'), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("header", _hoisted_23, [
        _createElementVNode("button", {
          class: "icon-button menu-button",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawer = !_ctx.drawer)),
          "aria-label": "Menu openen"
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "fas fa-bars" }, null, -1)
        ]))]),
        _createVNode(_component_router_link, {
          class: "header-mark",
          to: "/overview/flow",
          "aria-label": "Simplex Flow"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: "/favicon.ico",
              alt: ""
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_24, [
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Simplex Flow", -1)),
          (_ctx.pageTitle)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-chevron-right crumb-separator" }, null, -1)),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.pageTitle), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "icon-button",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cycleAppearance && _ctx.cycleAppearance(...args))),
            title: _ctx.appearanceLabel,
            "aria-label": _ctx.appearanceLabel
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.appearanceIcon)
            }, null, 2)
          ], 8, _hoisted_27),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.userInitial), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "icon-button",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
            title: "Uitloggen",
            "aria-label": "Uitloggen"
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("main", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ])
  ]))
}